export const EVENTS = {
  SIGNUP: {
    STEP_VIEWED: 'signup_step_viewed',
    EMAIL_ENTERED: 'signup_email_entered',
    ACCOUNT_CREATED: 'signup_account_created',
    EMAIL_VERIFIED: 'signup_email_verified',
    COMPANY_ENTERED: 'signup_company_entered',
    COMPLETED: 'signup_completed',
    FEDERATED_INITIATED: 'signup_federated_initiated',
  },
  LOGIN: {
    COMPLETED: 'login_completed',
    FEDERATED_INITIATED: 'login_federated_initiated',
    FEDERATED_COMPLETED: 'login_federated_completed',
  },
  ONBOARDING: {
    COMPLETED: 'onboarding_completed',
  },
  CONVERSATION: {
    STARTED: 'conversation_started',
    MESSAGE_SENT: 'conversation_message_sent',
    ENDED: 'conversation_ended',
  },
  WORKSPACE: {
    CREATED: 'workspace_created',
  },
  TEAM: {
    USERS_INVITED: 'users_invited',
  },
  BILLING: {
    CHECKOUT_INITIATED: 'checkout_initiated',
    SUBSCRIPTION_ACTIVATED: 'subscription_activated',
  },
  WIKI: {
    EXPLAIN_REQUESTED: 'wiki_explain_requested',
  },
  CONNECTIONS: {
    ACCOUNT_CONNECTED: 'account_connected',
    SHOPIFY_CONNECT_CLICKED: 'shopify_connect_clicked',
    OAUTH_EXCHANGE_STARTED: 'oauth_exchange_started',
    OAUTH_EXCHANGE_FAILED: 'oauth_exchange_failed',
  },
  OBJECTIVES: {
    MODAL_VIEWED: 'objectives_modal_viewed',
    SUGGESTIONS_LOADED: 'objectives_suggestions_loaded',
    CUSTOM_ADDED: 'objectives_custom_added',
    SAVED: 'objectives_saved',
    MODAL_DISMISSED: 'objectives_modal_dismissed',
    SETTINGS_VIEWED: 'objectives_settings_viewed',
    CREATED: 'objectives_created',
    UPDATED: 'objectives_updated',
    DELETED: 'objectives_deleted',
    DETAIL_OPENED: 'objectives_detail_opened',
    DETAIL_TAB_TOGGLED: 'objectives_detail_tab_toggled',
    ACTION_CLICKED: 'objectives_action_clicked',
    TOUR_COMPLETED: 'objectives_tour_completed',
  },
} as const;
